import { db, FieldValue } from "../../plugins/firebase";

export const organizations = {
  namespaced: true,
  state: {
    organizations: [],
    members: [],
    organizationsListener: null
  },
  getters: {
    organizations(state) {
      return state.organizations;
    },
    getOrganization(state) {
      return id => {
        return state.organizations.find(o => o.id === id);
      };
    },
    getMembers: (_, getters) => id => {
      const organization = getters.getOrganization(id);

      if (!organization) {
        return;
      }

      const members = [];

      for (let [key, value] of Object.entries(organization.ballots)) {
        const member = {};
        member.ballotId = key;
        let count = 1;
        value.ssn.forEach(element => {
          member["ssn" + count.toString()] = element;
          count++;
        });

        members.push(member);
      }

      return members;
    }
  },
  mutations: {
    async setOrganizationsListener(state, listener) {
      if (!listener && state.organizationsListener) {
        // unsub
        await state.organizationsListener();
      }

      state.organizationsListener = listener;
    },
    setOrganizations(state, organizations) {
      state.organizations = organizations;
    },
    addOrganization(state, organization) {
      if (organization == null || organization.deleted !== false) {
        return;
      }
      const exists = state.organizations.find(o => o.id === organization.id);
      if (exists) {
        return;
      }

      state.organizations.push(organization);
    },

    updateOrganization(state, organization) {
      if (organization == null || organization.deleted !== false) {
        return;
      }
      state.organizations = state.organizations.map(o =>
        o.id === organization.id ? organization : o
      );
    },

    deleteOrganization(state, id) {
      state.organizations = state.organizations.filter(o => o.id !== id);
    }
  },
  actions: {
    load: async ({ rootState, commit }) => {
      // .where("admin", "array-contains-any", [state.auth.uid])
      await commit("setOrganizationsListener", null);

      if (!rootState.auth.auth) {
        return;
      }

      const uid = rootState.auth.auth.uid;

      const listener = db
        .collection("organizations")
        .where("admin", "array-contains-any", [uid])
        .where("deleted", "==", false)
        .onSnapshot(snapshot => {
          snapshot.docChanges().forEach(change => {
            if (change.type === "added") {
              const organization = { id: change.doc.id, ...change.doc.data() };
              commit("addOrganization", organization);
            }
            if (change.type === "modified") {
              const organization = { id: change.doc.id, ...change.doc.data() };
              commit("updateOrganization", organization);
            }
            if (change.type === "removed") {
              if (change.type === "removed") {
                commit("deleteOrganization", change.doc.id);
              }
            }
          });
        });

      await commit("setOrganizationsListener", listener);
    },
    createOrganization: async ({ rootState }, organization) => {
      try {
        return db.collection("organizations").add({
          ...organization,
          members: [],
          ballots: {},
          admin: [rootState.auth.auth.uid],
          deleted: false
        });
      } catch (error) {
        console.log(error);
        return;
      }
    },
    editOrganization: async (
      _,
      {
        organizationId,
        name,
        ssn,
        email,
        admin,
        address,
        zipcode,
        city,
        nameGdpr,
        emailGdpr,
        invoiceEmail,
        invoicingStatus,
        invoiceReference
      }
    ) => {
      if (ssn === undefined) {
        ssn = null;
      }
      if (email === undefined) {
        email = null;
      }
      if (address === undefined) {
        address = null;
      }
      if (zipcode === undefined) {
        zipcode = null;
      }
      if (city === undefined) {
        city = null;
      }
      if (nameGdpr === undefined) {
        nameGdpr = null;
      }
      if (emailGdpr === undefined) {
        emailGdpr = null;
      }
      if (invoiceEmail === undefined) {
        invoiceEmail = null;
      }
      if (invoicingStatus === undefined) {
        invoicingStatus = null;
      }
      if (invoiceReference === undefined) {
        invoiceReference = null;
      }

      try {
        await db
          .collection("organizations")
          .doc(organizationId)
          .set(
            {
              name,
              ssn,
              email,
              admin,
              address,
              zipcode,
              city,
              nameGdpr,
              emailGdpr,
              invoiceEmail,
              invoicingStatus,
              invoiceReference
            },
            { merge: true }
          );

        return true;
      } catch (error) {
        console.log(error);
        return;
      }
    },
    deleteOrganization: async (_, { organizationId }) => {
      try {
        await db
          .collection("organizations")
          .doc(organizationId)
          .set({ deleted: FieldValue.serverTimestamp() }, { merge: true });

        return true;
      } catch (error) {
        console.log(error);
        return;
      }
    }
  }
};
